"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Wrench, Paintbrush, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurServices() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const services = [{
    icon: Wrench,
    title: "Our Services",
    description: "Expert restoration of damaged panels and bodywork with precision welding and reinforcement to bring your motorcycle back to factory standards.",
    cta: "Learn More",
    ctaLink: "/ServicesPage"
  }, {
    icon: Paintbrush,
    title: "Motorcycle Panel Repairs & Respray ",
    description: "We specialise in repairing cracked, scratched, and damaged motorcycle panels. Every fairing is restored, prepped, and resprayed using high-quality materials for a durable and flawless finish. OEM colour matching and custom paint designs available.",
    cta: "View Portfolio",
    ctaLink: "/PortfolioPage"
  }, {
    icon: Shield,
    title: "Motorcycle Fair Plastic Welding",
    description: "We fix cracked, snapped, and split fairings using professional plastic welding techniques for a strong, long-lasting repair. Ideal before sanding, shaping, and respraying.",
    cta: "Get Quote",
    ctaLink: "/ContactPage"
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-display font-bold text-foreground mb-4">
            Our Services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Professional motorcycle panel respray and crash repair services with expert craftsmanship and attention to detail.
          </p>
        </div>

        <div ref={imageRef} className={`mb-12 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <div className="relative w-full max-w-4xl mx-auto overflow-hidden rounded-lg shadow-medium">
            <img src="https://custom-candy.com/wp-content/uploads/2025/12/image_h24l5m11.png" alt="Custom candy paint respray showcasing expert motorcycle panel restoration and finishing" className="w-full h-auto object-cover" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: visibilities[i] ? `${i * 150}ms` : "0ms"
          }}>
                <Card className="h-full flex flex-col shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1">
                  <CardHeader className="text-center pb-4">
                    <div className="mx-auto mb-4 flex items-center justify-center w-16 h-16 rounded-full bg-primary/10">
                      <Icon className="w-8 h-8 text-primary" strokeWidth={2} />
                    </div>
                    <CardTitle className="text-xl font-display font-semibold text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <p className="text-muted-foreground text-center leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                  <CardFooter className="pt-4 justify-center">
                    <Link to={service.ctaLink}>
                      <Button variant="outline" size="default" className="transition-transform duration-[80ms] ease-out hover:scale-[1.02] active:scale-100">
                        {service.cta}
                      </Button>
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}